import React, { useState, useCallback, useEffect } from 'react'
import {  getTenLog } from '../../utils/api';
import LocalLoader from '../../Components/Loader/LocalLoader';
import { FilterWrapper } from '../../assets/styles/FilterStyle';
import { useLocation } from 'react-router-dom';

const safeParseJson = (str) => {
  try {
    const parsed = JSON.parse(str);
    if (typeof parsed === 'string') {
      try {
        return JSON.parse(parsed);
      } catch {
        return parsed;
      }
    }
    return parsed;
  } catch {
    return str;
  }
};

const formatJson = (str) => {
  const parsed = safeParseJson(str);
  if (typeof parsed === 'string') return parsed;
  return JSON.stringify(parsed, null, 2);
};

function LogPage() {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState(null);
  const [copied, setCopied] = useState(null);
  const [txnIdInput, setTxnIdInput] = useState("");

    const location = useLocation();

  const detail = location.state?.detail;

  const handleCopy = useCallback((label, text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(label);
      setTimeout(() => setCopied(null), 2000);
    });
  }, []);

  const getLogData = async (texId) => {
     if(!texId)return;
    setLoading(true);
    setLogs(null);
    const payload = { txnId: texId?.trim() }
    getTenLog(payload).then((resp) => {
      setLoading(false);
      if (resp?.data?.success) {
        setLogs(resp?.data?.data);
      }
    });
  };

  useEffect(()=>{
    if(!detail) return;
    setTxnIdInput(detail?.transactionId);
getLogData(detail?.transactionId)
  },[detail])

  const requestLog = logs?.[0];
  const responseLog = logs?.[1];
  const callBack = logs?.[2];

  return (
    <div style={{ padding: "30px" }}>
      
      <FilterWrapper className="display_data" style={{marginTop:"40px"}}>
        <div className="filterBox">
          <div className="flex" style={{ width: "100%", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
            <h2 style={{ color: "#fff" }}>Transaction Logs</h2>
            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
              <div className="input-field">
                <input
                  className="input_select_field"
                  type="text"
                  placeholder="Enter Txn ID"
                  value={txnIdInput}
                  onChange={(e) => setTxnIdInput(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && getLogData()}
                  style={{ width: "240px" }}
                />
              </div>
              <button
                className="userlist_btn"
                onClick={()=>getLogData(txnIdInput)}
                disabled={!txnIdInput.trim()}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </FilterWrapper>

      {loading && <LocalLoader />}

      {!loading && !logs && (
        <div className="container" style={{ textAlign: "center", color: "#8B9CA8" }}>
          {txnIdInput.trim() ? "No data found for this Txn ID" : "Enter a Txn ID and click Search"}
        </div>
      )}

      {!loading && logs && (
        <>
        <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
          <div
            className="container"
            style={{
              flex: 1,
              minWidth: "300px",
              width: "100%",
              borderTop: "4px solid #00BAF2",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span
                  style={{
                    background: "#00BAF2",
                    color: "#fff",
                    padding: "4px 14px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {requestLog?.apiType || "REQUEST"}
                </span>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#002970" }}>
                  REQUEST
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {requestLog?.txnId && (
                  <span style={{ fontSize: "11px", color: "#8B9CA8" }}>
                    Txn: {requestLog.txnId}
                  </span>
                )}
                <button
                  onClick={() => handleCopy('request', formatJson(requestLog?.apiLog))}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                >
                  {copied === 'request' ? (
                    <span style={{ color: "#40B816", fontSize: "11px", fontWeight: 600 }}>
                      Copied!
                    </span>
                  ) : (
                    <i className="fa-regular fa-copy" style={{ color: "#8B9CA8", fontSize: "14px" }}></i>
                  )}
                </button>
              </div>
            </div>

            <pre
              style={{
                background: "#F6F6F6",
                border: "1px solid #00297024",
                borderRadius: "6px",
                padding: "16px",
                fontSize: "12px",
                lineHeight: 1.6,
                overflow: "auto",
                maxHeight: "500px",
                margin: 0,
                fontFamily: "'Courier New', monospace",
                color: "#001A16",
                 scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none"
              }}
            >
              {requestLog ? formatJson(requestLog.apiLog) : "No request data"}
            </pre>

            {requestLog?.createdAt && (
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "11px",
                  color: "#8B9CA8",
                  textAlign: "right",
                }}
              >
                {requestLog.createdAt}
              </div>
            )}
          </div>

          <div
            className="container"
            style={{
              flex: 1,
              minWidth: "300px",
              width: "100%",
              borderTop: "4px solid #40B816",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span
                  style={{
                    background: "#40B816",
                    color: "#fff",
                    padding: "4px 14px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {responseLog?.apiType || "RESPONSE"}
                </span>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#002970" }}>
                  RESPONSE
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {responseLog?.txnId && (
                  <span style={{ fontSize: "11px", color: "#8B9CA8" }}>
                    Txn: {responseLog.txnId}
                  </span>
                )}
                <button
                  onClick={() => handleCopy('response', formatJson(responseLog?.apiLog))}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                >
                  {copied === 'response' ? (
                    <span style={{ color: "#40B816", fontSize: "11px", fontWeight: 600 }}>
                      Copied!
                    </span>
                  ) : (
                    <i className="fa-regular fa-copy" style={{ color: "#8B9CA8", fontSize: "14px" }}></i>
                  )}
                </button>
              </div>
            </div>

            <pre
              style={{
                background: "#F6F6F6",
                border: "1px solid #00297024",
                borderRadius: "6px",
                padding: "16px",
                fontSize: "12px",
                lineHeight: 1.6,
                overflow: "auto",
                maxHeight: "500px",
                margin: 0,
                fontFamily: "'Courier New', monospace",
                color: "#001A16",
                 scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none"
              }}
            >
              {responseLog ? formatJson(responseLog.apiLog) : "No response data"}
            </pre>

            {responseLog?.createdAt && (
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "11px",
                  color: "#8B9CA8",
                  textAlign: "right",
                }}
              >
                {responseLog.createdAt}
              </div>
            )}
          </div>
        </div>
         <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
         

          <div
            className="container"
            style={{
              flex: 1,
              minWidth: "300px",
              width: "100%",
              marginTop:"20px",
              borderTop: "4px solid #1616b8",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span
                  style={{
                    background: "#40B816",
                    color: "#fff",
                    padding: "4px 14px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  CallBack
                </span>
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#002970" }}>
                  RESPONSE
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {callBack?.txnId && (
                  <span style={{ fontSize: "11px", color: "#8B9CA8" }}>
                    Txn: {callBack?.txnId}
                  </span>
                )}
                <button
                  onClick={() => handleCopy('callback', formatJson(callBack?.apiLog))}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                >
                  {copied === 'callback' ? (
                    <span style={{ color: "#40B816", fontSize: "11px", fontWeight: 600 }}>
                      Copied!
                    </span>
                  ) : (
                    <i className="fa-regular fa-copy" style={{ color: "#8B9CA8", fontSize: "14px" }}></i>
                  )}
                </button>
              </div>
            </div>

            <pre
              style={{
                background: "#F6F6F6",
                border: "1px solid #00297024",
                borderRadius: "6px",
                padding: "16px",
                fontSize: "12px",
                lineHeight: 1.6,
                overflow: "auto",
                maxHeight: "500px",
                margin: 0,
                fontFamily: "'Courier New', monospace",
                color: "#001A16",
                 scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none"
              }}
            >
              {callBack ? formatJson(callBack?.apiLog) : "No response data"}
            </pre>

            {callBack?.createdAt && (
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "11px",
                  color: "#8B9CA8",
                  textAlign: "right",
                }}
              >
                {callBack?.createdAt}
              </div>
            )}
          </div>
        </div>
        </>
        
      )}
    </div>
  )
}

export default LogPage
